import { GetterTree } from 'vuex'
import { RootState } from '@/app/common/types/root-state.type'
import { InvoiceState } from '@/app/invoice/store/state'

export const getters: GetterTree<InvoiceState, RootState> = {

}
